import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Tabs as ReactTabs, TabList as ReactTabList, Tab, TabPanel as ReactTabPanel } from 'react-tabs';
import { config } from '../helpers/config';

var Tabs = function Tabs(_ref) {
  var rest = Object.assign({}, _ref);
  return React.createElement(ReactTabs, Object.assign({
    className: "tabs",
    disabledTabClassName: config.classes.disabled,
    selectedTabClassName: config.classes.active,
    selectedTabPanelClassName: config.classes.active
  }, rest));
};

var TabList = function TabList(_ref2) {
  var rest = Object.assign({}, _ref2);
  return React.createElement(ReactTabList, Object.assign({
    className: "tabs-list"
  }, rest));
};

TabList.tabsRole = 'TabList';

var TabPanel = function TabPanel(_ref3) {
  var selected = _ref3.selected,
      rest = _objectWithoutPropertiesLoose(_ref3, ["selected"]);

  return React.createElement(ReactTabPanel, Object.assign({
    selected: selected,
    className: "tabs-panel"
  }, rest));
};

TabPanel.tabsRole = 'TabPanel';
export { Tabs, TabList, Tab, TabPanel };